import React, { useEffect } from "react";

const SCRIPT_ID = "lunacal-bush-maps-embed";
const TARGET_ID = "my-lunacal-inline-bush-maps";

/**
 * Lunacal inline booking embed for Bush Maps.
 * Loads the Lunacal SDK once per session and mounts the inline widget
 * into the target div. Safe across React re-mounts (HMR / navigation).
 */
export default function LunacalBooking() {
  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return;

    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.type = "text/javascript";
    s.text = `
      (function(L,U,N){let p=(a,ar)=>a.q.push(ar),d=L.document;L.Lunacal=L.Lunacal||function(){let lun=L.Lunacal,ar=arguments;if(!lun.loaded){lun.ns={};lun.q=lun.q||[];d.head.appendChild(d.createElement("script")).src=U;lun.loaded=!0}if(ar[0]===N){const api=function(){p(api,arguments)};const ns=ar[1];api.q=api.q||[];if(typeof ns==="string"){lun.ns[ns]=lun.ns[ns]||api;p(lun.ns[ns],ar);p(lun,["initNamespace",ns])}else p(lun,ar);return}p(lun,ar)};if(!L.Cal)L.Cal=L.Lunacal})(window,"https://app.lunacal.ai/embed/embed.js","init");
      Lunacal("init","bush-maps",{origin:"https://app.lunacal.ai"});
      Lunacal.config = Lunacal.config || {};
      Lunacal.config.forwardQueryParams = true;
      Lunacal.ns["bush-maps"]("inline",{ elementOrSelector:"#${TARGET_ID}", config:{layout:""}, calLink:"calendarbooking/bush-maps" });
      Lunacal.ns["bush-maps"]("preload",{ calLink:"calendarbooking/bush-maps", type:"inline", options:{prerenderIframe:true} });
      Lunacal.ns["bush-maps"]("ui",{"theme":"dark","styles":{"branding":{}},"hideEventTypeDetails":false,"layout":"","cssVarsPerTheme":{"light":{"theme-border":"#1F1F1F","theme-background-primary":"#018CFF","theme-background-secondary":"#33353A","theme-background-card":"#090909","theme-background-base":"#090909","theme-text-primary":"#ffffff","theme-text-secondary":"#ffffff","theme-text-card":"#ffffff","theme-text-base":"#ffffff","theme-rounded-base":"12px","theme-rounded-calendar":"20px","theme-rounded-timeslot":"999px","theme-rounded-day":"999px","theme-rounded-button":"999px","theme-shadow-calendar":"1.5px 8.5px 4px 0px #0000001A","theme-shadow-button":"0px 0px 0px 0px #D1519A88","theme-shadow-timeslot":"0px 0px 0px 0px #000000","theme-font-family":"Outfit"},"dark":{"theme-border":"#1F1F1F","theme-background-primary":"#018CFF","theme-background-secondary":"#33353A","theme-background-card":"#090909","theme-background-base":"#090909","theme-text-primary":"#ffffff","theme-text-secondary":"#ffffff","theme-text-card":"#ffffff","theme-text-base":"#ffffff","theme-rounded-base":"12px","theme-rounded-calendar":"20px","theme-rounded-timeslot":"999px","theme-rounded-day":"999px","theme-rounded-button":"999px","theme-shadow-calendar":"1.5px 8.5px 4px 0px #0000001A","theme-shadow-button":"0px 0px 0px 0px #D1519A88","theme-shadow-timeslot":"0px 0px 0px 0px #000000","theme-font-family":"Outfit"}},"displayedContent":{"image":true,"name":true,"designation":true,"description":true,"eventName":true,"highlightBar":false},"background":{"type":"animated","presetId":"retro-grid"},"stylePreset":"blueshine"});
    `;
    document.body.appendChild(s);
  }, []);

  return (
    <section
      id="book"
      data-testid="section-book"
      className="relative py-24 md:py-32 bg-[#2C3C2B] text-[#FDFBF7] bm-noise"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <div className="text-[11px] tracking-[0.28em] uppercase text-[#E9C7A8] font-semibold mb-6">
            Book a Discovery Call
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            Find a time that works.
          </h2>
          <p className="mt-6 text-[#D7CFC0] text-lg leading-relaxed">
            A 30-minute call to talk about your Country, your project and how
            Bush Mapping might help. No pressure, no obligation — we just
            listen first.
          </p>
        </div>

        <div className="bg-[#090909] border border-[#1F1F1F] p-1 md:p-2 rounded-[18px] shadow-2xl">
          <div
            id={TARGET_ID}
            style={{ width: "100%", height: "720px", overflow: "auto" }}
          />
        </div>

        <p className="mt-8 text-sm text-[#A89E94] tracking-wide">
          Prefer to send a written enquiry first?{" "}
          <a
            href="#contact"
            className="text-[#E9C7A8] underline-offset-4 hover:underline"
          >
            Scroll to the contact form ↓
          </a>
        </p>
      </div>
    </section>
  );
}
